<template>
  <section class="body">
    <component
      :class="{'withMinHeight': layoutName.indexOf(['businesses-layout']) !== -1}"
      v-if="layout"
      :is="layoutName"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import BookingVehicle from '../Booking/BookingVehicle'
import VehiclesLayout from '../Vehicles/VehiclesLayout'
import VehicleDetailsLayout from '../Vehicles/VehicleDetails/VehicleDetailsLayout'
import HomeLayout from '../Home/HomeLayout'
import Layout404 from '../Home/Layout404'
import DegradedModeLayout from '../Quotation/DegradedMode/DegradedModeLayout'
import IdentificationLayout from '../Identification/IdentificationLayout'
import ForgotPasswordLayout from '../Identification/ForgotPasswordLayout/ForgotPasswordLayout'
import CreateAccount from '../Identification/CreateAccount/CreateAccount'
import UserProfile from '../UserProfile/UserProfile'
import ContactLayout from '../Contact/ContactLayout'
import BusinessesLayout from '../Businesses/BusinessesLayout'
import BusinessDetailsLayout from '../Businesses/BusinessDetails/BusinessDetailsLayout'
import PaymentSuccess from '../Quotation/Payment/PaymentSuccess'
import PaymentError from '../Quotation/Payment/PaymentError'
import PageLayout from '../Presto/PageLayout'
import FaqLayout from '../Faq/FaqLayout'
import ConfirmationMessageLayout from '../Confirmation/ConfirmationMessageLayout'
import ConfirmationLayout from '../Confirmation/ConfirmationLayout'

import MobilityLayout from '../Mobility/MobilityLayout'
import ZoeLayout from '../Zoe/ZoeLayout'

export default {
  name: 'RentBody',
  components: {
    BookingVehicle,
    VehiclesLayout,
    HomeLayout,
    Layout404,
    QuotationLayout: () => import(/* webpackChunkName: "body"  */ `../Quotation/QuotationLayout`),
    VehicleDetailsLayout,
    IdentificationLayout,
    ForgotPasswordLayout,
    CreateAccount,
    UserProfile,
    BusinessesLayout,
    BusinessDetailsLayout,
    ContactLayout,
    PaymentSuccess,
    PaymentError,
    PageLayout,
    DegradedModeLayout,
    FaqLayout,
    PasswordResetLayout: () => import(/* webpackChunkName: "body"  */ `../Identification/PasswordResetLayout`),
    ConfirmationMessageLayout,
    MobilityLayout,
    ConfirmationLayout,
    ZoeLayout,
  },
  computed: {
    ...mapState({
      layout: (state) => state.layout,
    }),
    layoutName() {
      return this.layout.toLowerCase()
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../_src/sass/config/vars';
@import '../../../../_src/sass/config/mixins';
@import '../../../../_src/sass/config/responsive';

.body {
  @include transition(0.3s ease all);

  min-height: auto;
  padding: 9rem 0 0;

  .withMinHeight {
    min-height: calc(100vh - 195px);
  }

  .nav-open & {
    @include openMobileNav;
  }

  @include teq-breakpoint($medium) {
    padding: 97px 0 0;
  }
}
</style>
